import { Component }         from '@angular/core';
import { ViewChild }         from '@angular/core';
import { NavController }     from 'ionic-angular';
import { AlertController }   from 'ionic-angular';
import { ModalController }   from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { Select }            from 'ionic-angular';
import { Events }            from 'ionic-angular';
import { TaskListViewModel } from './xv-task-list';
import { MLText, mlBroker }  from '../../services/MLText';
import { AppDataBroker }     from '../../services/AppData';
import { dmHotel }           from '../sign-in/xv-hotel';
import { SignInPage }        from '../sign-in/sign-in';
import { dmLoading }         from '../loading/loading';

import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";

@Component({
    selector:    'page-task-list',
    templateUrl: 'task-list.html'
})
export class TaskListPage {
    TaskList:          TaskListViewModel;
    ShowAlert:         (pTitle: string, pMessage: string) => void;
    NewLoading:        (pMessage: string)                 => dmLoading;
    BackToSignIn:      ()                                 => void;
    ShowOrderBySelect: ()                                 => void;
    ShowCalendar:      (
         pToday:  Date
        ,pCDay:   Date
        ,pTitle:  string
        ,pLangID: number
        ,pAction: (pCDay: Date) => void
    ) => void;

    app:          mlBroker;

    InPage:       boolean;

    @ViewChild('OrderBySelect') OrderBySelect: Select;

    constructor(
         public navCtrl:       NavController
        ,public alertCtrl:     AlertController
        ,public modalCtrl:     ModalController
        ,public loadingCtrl:   LoadingController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        console.log('initialise task-list');

        let hotel      = appDataBroker.GetAppData() as dmHotel;

        this.InPage    = true;

        this.app       = this.mlText.GetBroker('BookingEngineAppTexts');

        this.ShowAlert = (pTitle: string, pMessage: string) => {
            let alert = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = loadingCtrl.create({
                 content: pMessage
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (!loadingAPI.IsDismissed) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ShowOrderBySelect = () => {
            this.OrderBySelect.open();
        }

        this.ShowCalendar = (
             pToday:  Date
            ,pCDay:   Date
            ,pTitle:  string
            ,pLangID: number
            ,pAction: (pCDay: Date) => void
        ) => {
            let firstDay: Date = new Date();

            firstDay.setDate(pToday.getDate() - 100);

            const options: CalendarModalOptions = {
                 pickMode:        'single'
                ,title:            pTitle
                ,from:             firstDay
                ,defaultDate:      pCDay
                ,defaultScrollTo:  pCDay
                ,color:            'danger'
            };

            let calendar = this.modalCtrl.create(CalendarModal ,{
                options: options
            });

            calendar.onDidDismiss((
                 date: CalendarResult
                ,type: string
            ) => {
                if (
                    (type == 'cancel')
                ||  (type == 'backdrop')
                ||  (!date.dateObj)
                ) { return; }

                pAction(date.dateObj);
            });

            calendar.present();
        };

        this.BackToSignIn = () => {
            this.navCtrl.setRoot(SignInPage);
        };

        this.TaskList = new TaskListViewModel(
             mlText
            ,hotel
            ,this.BackToSignIn
            ,this.ShowAlert
            ,this.NewLoading
            ,this.ShowOrderBySelect
            ,this.ShowCalendar
        );
    }

    ionViewDidEnter() {
        this.TaskList.DidEnter();
    }

    ionViewDidLeave() {
        this.TaskList.DidLeave();
    }

    ionViewWillEnter() {
        this.InPage = true;
    }

    ionViewWillLeave() {
        this.InPage = false;
    }
}



// WEBPACK FOOTER //
// ./src/pages/task-list/task-list.ts